import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormControl, FormLabel, Input, Button, Flex } from '@chakra-ui/react';
import axios from 'axios';

const PersonalInfo = () => {
  const navigate = useNavigate();
  const [formDataToSend, setData] = useState({
    passportNumber: "",
    passportImage: "",
    personalNumber:"",
    personalNumberImage: "",
    address: "",
    city: "",
    state: "",
    zipcode: "",
    proofOfAddressImage: ""
  });

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    setData({ ...formDataToSend, [name]: type === 'checkbox' ? checked : value });
  };

  const [files, setFiles] = useState({
    passportImage: null,
    personalNumberImage: null,
    proofOfAddressImage: null,});

  const handleFileChange = (e) => {
    const { name, files: selectedFiles } = e.target;
    setFiles((prev) => ({
      ...prev,
      [name]: selectedFiles[0],
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  
    const data = new FormData();
  
    // Append text fields
    Object.entries(formDataToSend).forEach(([key, value]) => {
      data.append(key, value);
    });
  
    // Append file fields
    Object.entries(files).forEach(([key, file]) => {
      if (file) {
        console.log("Appending file field:", key);
        data.append(key, file);
      }
    });
  
    axios.post(`/api/register/personal-info`, data, {
      headers: {
        // NOTE: Don't manually set Content-Type when using FormData — let Axios handle it
        
      },
    })
    .then(response => {
      console.log("personalInfo: ", response);
      navigate(`/signup/contract`);
    })
    .catch(error => {
      if (error.response?.status === 400) {
        alert("User already exists");
      } else {
        console.error("Submission error:", error);
      }
    });
  };
  

  return (
    <form onSubmit={handleSubmit}>
       <Flex
        align="center"
        wrap="wrap"
        justify="space-around"
        minHeight={{ base: "60vh", lg: "50vh" }}
        maxW={{ base: "md", lg: "lg" }}
        mt={0}
        p={8}
      >
        <FormControl mt={4} isRequired>
          <FormLabel fontSize="md">PASSPORT #</FormLabel>
          <Input type="text" name="passportNumber" value={formDataToSend.passportNumber} onChange={handleChange} required/>
        </FormControl>
        <FormControl mt={4} isRequired>
          <FormLabel>UPLOAD PASSPORT IMAGE</FormLabel>
          <Input type="file" accept="image/*" name="passportImage" onChange={handleFileChange} />
        </FormControl>
        <FormControl mt={4} isRequired>
          <FormLabel>ITIN. EIN, SSN #</FormLabel>
          <Input type="text" name="personalNumber" value={formDataToSend.personalNumber} onChange={handleChange} />
        </FormControl>
        <FormControl mt={4} isRequired>
          <FormLabel>UPLOAD ITIN, EIN, OR SSN IMAGE</FormLabel>
          <Input type="file" accept="image/*" name="personalNumberImage" onChange={handleFileChange} />
        </FormControl>
        <FormControl mt={4} isRequired>
          <FormLabel>ADDRESS</FormLabel>
          <Input type="text" name="address" value={formDataToSend.address} onChange={handleChange} />
        </FormControl>
        <FormControl mt={4} isRequired>
          <FormLabel>CITY</FormLabel>
          <Input type="text" name="city" value={formDataToSend.city} onChange={handleChange} />
        </FormControl>
        <FormControl mt={4} isRequired>
          <FormLabel>STATE</FormLabel>
          <Input type="text" name="state" value={formDataToSend.state} onChange={handleChange} />
        </FormControl>
        <FormControl mt={4} isRequired>
          <FormLabel>ZIPCODE</FormLabel>
          <Input type="text" name="zipcode" value={formDataToSend.zipcode} onChange={handleChange} />
        </FormControl>
        <FormControl mt={4} isRequired>
          <FormLabel>UPLOAD PROOF OF ADDRESS IMAGE</FormLabel>
          <Input type="file" accept="image/*" name="proofOfAddressImage" onChange={handleFileChange} />
        </FormControl>
        <Button type="submit" mt={8} colorScheme="blue" width="35%">Next</Button>
      </Flex>
    </form>
  )
}

export default PersonalInfo;